










import { MrfiktivCustomFieldListElementViewModelGen } from "@/services/mrfiktiv/v1/data-contracts";
import { Component, Prop, Vue } from "vue-property-decorator";
import SelectCustomFields from "@/components/report/SelectCustomFields.vue";

@Component({
  components: {
    SelectCustomFields
  }
})
export default class CustomFieldConfigurationForm extends Vue {
  @Prop()
  value!: MrfiktivCustomFieldListElementViewModelGen[];

  @Prop({ default: false })
  disabled!: boolean;
}
